export default __webpack_public_path__ + "static/media/failed.5499b968.svg";